<div class="viewers-panel mat-elevation-z4">
  <section
    class="read-receipts-popover"
    role="alert"
    aria-live="polite"
    >
    @if (viewersLoading) {
      <div class="loading-spinner">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    } @else {
      <p
        class="comment-viewers-title"
        translate="read-receipts-viewed-by"
      ></p>
      @for (viewer of viewers; track viewer) {
        <div class="comment-viewers-item">
          <span class="comment-viewers-name">{{ viewer.name }}</span>
          <span class="comment-viewers-date">{{ viewer.viewed_at }}</span>
        </div>
      }
    }
  </section>
</div>